export default __webpack_public_path__ + "static/GT-America-Standard-Bold-Italic-77ab1784c0406a279a3e874bd67e157f.woff2";